import React from 'react';
import { Button, Card, CardContent, CircularProgress, Container, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PropTypes from 'prop-types';
import { Avatar, ButtonWrapper, Wrapper } from './styles';

function ConsentScreen({ clientName, userName, onApprove, onDeny, isLoading = false }) {
  return (
    <Container component="main" maxWidth="sm">
      <Wrapper>
        <Avatar>
          <CheckCircleOutlineIcon sx={{ width: 36, height: 36 }} />
        </Avatar>

        <Typography component="h1" variant="h5" sx={{ mt: 2, mb: 1 }}>
          Запрос доступа
        </Typography>

        <Card sx={{ mt: 3, width: '100%' }}>
          <CardContent>
            <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
              Приложение <strong>{clientName}</strong> запрашивает доступ к данным пользователя{' '}
              <strong>{userName}</strong> в ВИСТАР-М
            </Typography>

            <Typography color="textSecondary" textAlign="center">
              Нажмите кнопку «Разрешить» для предоставления доступа
            </Typography>

            <ButtonWrapper>
              <Button fullWidth variant="outlined" onClick={onDeny} disabled={isLoading}>
                Отказать
              </Button>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={onApprove}
                disabled={isLoading}
                sx={{
                  position: 'relative',
                }}
              >
                {isLoading ? <CircularProgress size={24} sx={{ position: 'absolute' }} /> : 'Разрешить'}
              </Button>
            </ButtonWrapper>
          </CardContent>
        </Card>
      </Wrapper>
    </Container>
  );
}

ConsentScreen.propTypes = {
  clientName: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  onApprove: PropTypes.func.isRequired,
  onDeny: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

ConsentScreen.defaultProps = {
  isLoading: false,
};

export default ConsentScreen;
